/* eslint-disable @stylistic/max-len, no-inline-comments */
import type {ComponentType} from 'react';

import dynamic from 'next/dynamic';

import type {Config} from 'types/payload-types';

const Features = dynamic(async () => (await import(/* webpackChunkName: "Features" */'./Features')).Features, {ssr: true});
const FeaturesBig = dynamic(async () => (await import(/* webpackChunkName: "FeaturesBig" */'./FeaturesBig')).FeaturesBig, {ssr: true});
const FullsizeMoodVideo = dynamic(async () => (await import(/* webpackChunkName: "FullsizeMoodVideo" */'./FullsizeMoodVideo')).FullsizeMoodVideo, {ssr: true});
const FullsizeVideo = dynamic(async () => (await import(/* webpackChunkName: "FullsizeVideo" */'./FullsizeVideo')).FullsizeVideo, {ssr: true});
const Hero = dynamic(async () => (await import(/* webpackChunkName: "Hero" */'./Hero')).Hero, {ssr: true});
const OnlineShops = dynamic(async () => (await import(/* webpackChunkName: "OnlineShops" */'./OnlineShops')).OnlineShops, {ssr: true});
const StoreFinder = dynamic(async () => (await import(/* webpackChunkName: "StoreFinder" */'./StoreFinder')).StoreFinder, {ssr: true});
const UspModule = dynamic(async () => (await import(/* webpackChunkName: "UspModule" */'./UspModule')).UspModule, {ssr: true});

type BlockComponentMap = {
    [K in keyof Config['blocks']]: ComponentType<any>;
};

export const BlockMap: BlockComponentMap = {
    Features,
    FeaturesBig,
    FullsizeMoodVideo,
    FullsizeVideo,
    Hero,
    OnlineShops,
    StoreFinder,
    USPModule: UspModule
};